import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";
import { Target, ArrowRight, RefreshCw } from "lucide-react";

export default function MissedDrillIntroPage() {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/quizzes/missed");
      setCount(data.count);
      setLoading(false);
    })();
  }, []);

  return (
    <AppLayout>
      <div className="max-w-3xl mx-auto px-6 py-14" data-testid="missed-drill-intro">
        <div className="overline mb-3">Personal drill</div>
        <h1 className="font-serif text-5xl text-[var(--dw-navy)] mb-4 tracking-tight leading-tight">
          Drill only what you missed.
        </h1>
        <p className="text-neutral-700 leading-relaxed max-w-2xl mb-10">
          Every question you've ever answered incorrectly is queued here. Grind through them until
          they stick — this is the highest-leverage study session before test day.
        </p>

        <div className="dw-card p-8 mb-6 text-center">
          <Target className="w-8 h-8 text-[var(--dw-gold-soft)] mx-auto mb-4" strokeWidth={1.5} />
          <div className="overline mb-2">Currently queued</div>
          <div className="font-serif text-6xl text-[var(--dw-navy)] leading-none mb-2" data-testid="missed-count">
            {loading ? "—" : count}
          </div>
          <div className="text-sm text-neutral-500">{loading ? "Loading…" : count === 1 ? "question waiting for you" : "questions waiting for you"}</div>
        </div>

        {!loading && count === 0 ? (
          <div className="dw-card p-6 text-center">
            <div className="font-serif text-xl text-[var(--dw-navy)] mb-2">Nothing to drill — yet.</div>
            <p className="text-sm text-neutral-600 mb-4">Take a module quiz or the practice exam first. Anything you miss will appear here automatically.</p>
            <Link to="/modules" className="dw-btn-primary rounded-sm px-5 py-2.5 text-sm inline-flex items-center gap-2">
              Go to curriculum <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          </div>
        ) : (
          <Link
            to="/missed-drill/take"
            data-testid="start-missed-drill"
            className="dw-btn-gold rounded-sm px-6 py-3 text-sm inline-flex items-center gap-2"
          >
            <RefreshCw className="w-4 h-4" strokeWidth={1.5} /> Begin drill
          </Link>
        )}
      </div>
    </AppLayout>
  );
}
